const ACTION_PREPEND = 'customerRequest';
export const OPEN_PLAID = `${ACTION_PREPEND}/OPEN_PLAID`;
export const OPEN_AND_SAVE_PLAID = `${ACTION_PREPEND}/OPEN_AND_SAVE_PLAID`;
export const SAVE_PLAID_LINK = `${ACTION_PREPEND}/SAVE_PLAID_LINK`;
export const SAVE_PLAID_LINK_ERROR = `${ACTION_PREPEND}/SAVE_PLAID_LINK_ERROR`;
export const SAVE_PLAID_SUBSCRIPTION = `${ACTION_PREPEND}/SAVE_PLAID_SUBSCRIPTION`;
export const REFRESH_PLAID_BALANCE = `${ACTION_PREPEND}/REFRESH_PLAID_BALANCE`;
export const RESET_PLAID = `${ACTION_PREPEND}/RESET_PLAID`;
